import React from 'react';
import SearchAssist from '../../features/search/SearchAssist';
import { useSearchEditing } from '../../features/search/SearchEditingContext';
import AppUiScope from '../../app-ui/AppUiScope';
import baseline from '../../app-ui/baseline';
import { useSponsoredPlacements } from '../../features/ads/useSponsoredPlacements';
import { BrowseInlineAd } from '../../features/browse/BrowseSponsored';
import { withoutAdvertisedAlbums } from '../../features/search/resultPresentation';
import './SearchResultsApp.css';
import { useSearchResults } from '../../features/search/useSearchResults';
import { ContentState } from '../../components/content/DiscoveryContent';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { useSearchParams } from 'react-router-dom';
import useTrackPageView from '../../hooks/useTrackPageView';
import { PAGE_TYPE } from '../../constants/gaEnums';
import '../../styles/SearchResults.css';
import PageLayout from '../../components/layout/PageLayout';
import ProgressBar from '../../components/common/ProgressBar';
import SearchResultSection from './SearchResultSection';
import SearchResultHeader from './components/SearchResultHeader';

const SearchResults = () => {
  useTrackPageView({ pageType: PAGE_TYPE.SEARCH });
  const editing = useSearchEditing();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const { t } = useWebLocale();
  const result = useSearchResults(query);
  const campaigns = useSponsoredPlacements('SEARCH_RESULTS');
  const empty = { total: 0, items: [] };
  const searchResults = {
    artists: empty,
    albums: empty,
    playlists: empty,
    ...result.data,
  };
  const loading = Boolean(query?.trim()) && result.isPending;

  const visible = {
    ...searchResults,
    albums: {
      ...searchResults.albums,
      items: withoutAdvertisedAlbums(searchResults.albums.items, campaigns),
    },
  };
  return (
    <PageLayout paddingTop={{ xs: '12px', md: '24px' }}>
      {editing?.active ? (
        <SearchAssist />
      ) : (
        <AppUiScope className="pp-parity pp-browse pp-search-results" surface="lists">
          <ProgressBar isLoading={loading}>
            <ContentState query={{ ...result, isPending: loading }}>
              <div
                className="pp-search-results-sections"
                style={{ gap: baseline.tokens.spacing.xl }}
              >
                <SearchResultHeader query={query} results={searchResults} />
                {!query?.trim() ? (
                  <p>{t('searchIntro')}</p>
                ) : (
                  <>
                    {[
                      ['Reviews', visible.albums],
                      ['Artists', visible.artists],
                    ].map(
                      ([title, bucket]) =>
                        bucket.items.length > 0 && (
                          <SearchResultSection
                            key={title}
                            title={title}
                            count={bucket.total}
                            items={bucket.items}
                          />
                        ),
                    )}
                    {['albums', 'artists', 'playlists'].some(
                      (key) => searchResults[key].total > 0,
                    ) &&
                      campaigns.map((campaign) => (
                        <div
                          key={campaign.id}
                          className={`pp-search-summary-ad${visible.artists.items.length ? ' pp-search-summary-ad-after-rows' : ''}`}
                        >
                          <BrowseInlineAd campaign={campaign} />
                        </div>
                      ))}
                    {visible.playlists.items.length > 0 && (
                      <SearchResultSection
                        title="Mixes"
                        count={visible.playlists.total}
                        items={visible.playlists.items}
                      />
                    )}
                    {!['albums', 'artists', 'playlists'].some(
                      (key) => searchResults[key].items.length > 0,
                    ) && <p>{t('empty')}</p>}
                  </>
                )}
              </div>
            </ContentState>
          </ProgressBar>
        </AppUiScope>
      )}
    </PageLayout>
  );
};
export default SearchResults;
